import { CollegeTeamHighlight } from "@/models";
import restApiDispatcher from "@/store/utils/api-dispatcher";

const getCollegeTeamHighlight = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlight",
    loadingKey: "collegeTeamHighlightLoading",
    action: "showWithProfileId",
    commitType: "show",
    params
  });

const getCollegeTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlights",
    loadingKey: "collegeTeamHighlightsLoading",
    action: "index",
    commitType: "indexUnwrapped",
    params
  });

const getCollegeTeamHighlightsLimited = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlightsLimited",
    loadingKey: "collegeTeamHighlightsLoading",
    action: "indexLimited",
    commitType: "indexUnwrapped",
    params
  });

const createCollegeTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlight",
    loadingKey: "collegeTeamHighlightLoading",
    action: "create",
    commitType: "show",
    params
  });

const updateCollegeTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlight",
    loadingKey: "collegeTeamHighlightLoading",
    action: "update",
    commitType: "update",
    params
  });

const deleteCollegeTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlight",
    loadingKey: "collegeTeamHighlightsLoading",
    action: "delete",
    commitType: "show",
    params
  });

const updateImageForHighlight = (context, params) =>
  restApiDispatcher(context, {
    resource: CollegeTeamHighlight,
    storeKey: "collegeTeamHighlight",
    loadingKey: "collegeTeamHighlightLoading",
    action: "imageUpdate",
    commitType: "show",
    params
  });

const afterDeleteActions = (context, params) =>
  context.commit("AFTER_DELETE_ACTIONS", params.id);

export default {
  getCollegeTeamHighlight,
  getCollegeTeamHighlights,
  createCollegeTeamHighlights,
  updateCollegeTeamHighlights,
  deleteCollegeTeamHighlights,
  afterDeleteActions,
  updateImageForHighlight,
  getCollegeTeamHighlightsLimited
};
